import axios from 'axios';

const client = axios.create({
  baseURL: import.meta.env.VITE_APP_BELOZ_V2_ENDPOINT,
});

export async function setUserPersonalInfoService(authToken, personalInfo) {
  try {
    let { data } = await client.put('/user/personal-info', personalInfo, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    return data;
  } catch (err) {
    console.log(err);
    return {
      success: false,
    };
  }
}

export async function createUserAddress(authToken, address) {
  try {
    let { data } = await client.post('/user/user-address', address, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    return data;
  } catch (err) {
    console.log(err);
    return {
      success: false,
    };
  }
}

export async function createFirstTimeApplicationService(authToken, inputData) {
  try {
    let finalInputData = Object.assign(inputData, {
      initialChannel: 'WEB',
      destinationChannel: 'APP',
    });
    let { data } = await client.post(
      '/application/first-time',
      finalInputData,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    return {
      success: data.success,
      application: data.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
}

export async function executeUserCreditCheckService(
  beToken,
  deviceInfo,
  deviceIp,
) {
  try {
    let { data } = await client.post(
      '/user/credit-check/evaluation',
      {
        deviceInfo,
        deviceIp,
      },
      {
        headers: {
          Authorization: `Bearer ${beToken}`,
        },
      },
    );
    console.log(data);
    return data;
  } catch (error) {
    return {
      success: false,
    };
  }
}

export async function fetchApplicationCreditCheckStatusService(
  authToken,
  applicationId,
) {
  try {
    let { data } = await client.get(
      `/application/${applicationId}/credit-check-status`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    return data;
  } catch (err) {
    return {
      success: false,
    };
  }
}